module.exports = __webpack_public_path__ + "static/7-db8723d3c41390960890f7bda2ee6e26.png";